(function () {
  'use strict';

  var STORAGE_KEY = 'slay_ab_variant';

  function getVariant() {
    window.__SLAY_AB_VARIANT = 'A';
    try { localStorage.setItem(STORAGE_KEY, 'A'); } catch (e) {}
    return 'A';
  }

  function applyVariant(variant) {
    document.documentElement.setAttribute('data-ab-variant', 'A');

    var elements = document.querySelectorAll('.ab-loading[data-ab-a]');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var content = el.getAttribute('data-ab-a');

      if (content !== null && content !== '') {
        el.textContent = content;
      }

      el.classList.remove('ab-loading');
    }
  }

  var variant = getVariant();

  function run() {
    applyVariant(variant);
  }

  run();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }

  function startObserver() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          applyVariant(variant);
          break;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  window.SLAY_AB = {
    variant: 'A',
    storageKey: STORAGE_KEY
  };

  document.addEventListener('DOMContentLoaded', function () {
    try {
      var event = new CustomEvent('slay:ab:resolved', { detail: { variant: 'A' } });
      document.dispatchEvent(event);
    } catch (e) {}
  });
})();

/* ─────────────────────────────────────────────────────────────
   EXPERIMENT 2 — Review Photos (Disabled / Set to Control A)
───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var STORAGE_KEY = 'slay_ab_review_photos';

  function getVariant() {
    window.__SLAY_AB_REVIEW_VARIANT = 'A';
    try { localStorage.setItem(STORAGE_KEY, 'A'); } catch (e) {}
    return 'A';
  }

  var variant = getVariant();

  document.documentElement.setAttribute('data-ab-review-variant', 'A');

  window.SLAY_AB_REVIEW = {
    variant: 'A',
    storageKey: STORAGE_KEY
  };

  try { if (typeof mixpanel !== 'undefined') mixpanel.register({ ab_review_variant: 'A' }); } catch(e) {}

  document.addEventListener('DOMContentLoaded', function () {
    try {
      var ev = new CustomEvent('slay:ab:review:resolved', { detail: { variant: 'A' } });
      document.dispatchEvent(ev);
    } catch (e) {}
  });
})();

